import { render, staticRenderFns } from "./WaiterTemplateItem.vue?vue&type=template&id=5362c76b&scoped=true&lang=pug"
import script from "./WaiterTemplateItem.vue?vue&type=script&lang=ts"
export * from "./WaiterTemplateItem.vue?vue&type=script&lang=ts"
import style0 from "./WaiterTemplateItem.vue?vue&type=style&index=0&id=5362c76b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5362c76b",
  null
  
)

export default component.exports